import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EventLocationLayer from "../components/EventLocationLayer";


const EventLocationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Event Locations" />

        {/* ViewProfileLayer */}
        <EventLocationLayer />

      </MasterLayout>

    </>
  );
};

export default EventLocationPage; 
